var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('subcategoriesService', ['$http', function ($http) {
    return{
        getsubcategoriesbycategory: function (parentCategory) {
            return $http.get('storefrontapi/getsubcategoriesbycategory?parentCategory=' + parentCategory);
        },
    }
}]);
